import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './SuccessScreen.module.scss';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import Button, { ButtonProps } from 'components/UI/V3/Button/Button';
import React, { FunctionComponent, ReactNode } from 'react';
import clsx from 'clsx';

interface SuccessScreenProps {
    title: string;
    message: ReactNode;
    buttonLabel: string;
    buttonVariant?: ButtonProps['variant'];
    className?: string;
    onClick?: () => void;
}

export const SuccessScreen: FunctionComponent<SuccessScreenProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <FontAwesomeIcon
                icon={faCheckCircle}
                color="#5E8677"
                fontSize={72}
            />
            <span className={styles.title}>{props.title}</span>
            {props.message}
            <Button
                label={props.buttonLabel}
                variant={props.buttonVariant ?? 'black'}
                onClick={props.onClick}
                className={styles.button}
            />
        </div>
    );
};

export default SuccessScreen;
